import React from 'react';
import { ButtonTheme } from 'common/components/button/constants';
import { SelectorType } from 'common/query-builder/query-block/constants';
import { RowLabelType } from 'common/query-builder/query-entry-section/types';
import { MenuType } from 'common/query-builder/query-block/types';
import { Placement } from 'common/components/tooltip/types';
import { Translatable } from 'common/i18n';
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { QueryBlockReact } from 'common/query-builder/query-block';
import { TooltipReact } from 'common/components/tooltip';
import { useTranslation } from 'common/i18n/hooks';
import { withStyles } from 'common/util/react';
import { react2panel } from 'common/util/react2panel';
import { RHSInputType, TemplateField } from '../types';
import { FieldLabelReact } from './FieldLabelReact';
import css from './EventAndPropertySelector.inline.styl';
export const EventAndPropertySelector = (_ref: {
  eventKey: TemplateField;
  propertyKey: TemplateField;
  label: Translatable;
  disabled: boolean;
  tooltipText: Translatable;
  event: string;
  propertyKeyLabel: string;
  showReminderTooltip?: boolean;
  updateField: (updates: any, field: TemplateField, type: RHSInputType) => void;
  update: () => void;
  removeField: (field: TemplateField) => void;
  currentProjectId: number;
  eventField: any;
  propertyField: any;
}) => {
  let {
    eventKey,
    propertyKey,
    label,
    disabled,
    tooltipText,
    event,
    propertyKeyLabel,
    showReminderTooltip,
    updateField,
    update,
    removeField,
    currentProjectId,
    eventField,
    propertyField
  }: {
    eventKey: TemplateField;
    propertyKey: TemplateField;
    label: Translatable;
    disabled: boolean;
    tooltipText: Translatable;
    event: string;
    propertyKeyLabel: string;
    showReminderTooltip?: boolean;
    updateField: (updates: any, field: TemplateField, type: RHSInputType) => void;
    update: () => void;
    removeField: (field: TemplateField) => void;
    currentProjectId: number;
    eventField: any;
    propertyField: any;
  } = _ref;
  const {
    t,
    print
  } = useTranslation();
  return <div className='event-mapping-row short-field event-and-property-block-selector' data-sentry-component="EventAndPropertySelector" data-sentry-source-file="EventAndPropertySelector.tsx">
      <FieldLabelReact fieldName={print(label)} tooltipText={print(tooltipText)} data-sentry-element="FieldLabelReact" data-sentry-source-file="EventAndPropertySelector.tsx" />
      <div>
        <QueryEntrySectionReact className='query-entry-section' disabled={disabled} addEntryLabel={_ref2 => {
        let {
          t: _t
        } = _ref2;
        return _t("boards.rhs.event-list-property-placeholder");
      }} addEntryButtonLabel={_ref3 => {
        let {
          t: _t
        } = _ref3;
        return _t("boards.rhs.event-list-property-placeholder");
      }} projectId={currentProjectId} trackName='templates' disableAddEventFilters disableCloneEntry disableDeleteEntry={false} disableFirstTimeEventFilters rowLimit={1} rowLabelType={RowLabelType.None} rowLabelPrefixIcon='event' onUpdate={updates => {
        if (updates.entries.length) {
          updateField(updates, event as TemplateField, RHSInputType.Event);
        } else {
          removeField(eventKey);
          removeField(propertyKey);
        }
      }} onClick={() => update()} data-sentry-element="QueryEntrySectionReact" data-sentry-source-file="EventAndPropertySelector.tsx" />
      </div>

      {eventField && <div className='property-selector'>
          <div>
            <QueryBlockReact type={MenuType.Properties} projectId={currentProjectId} selectorType={SelectorType.Button} theme={ButtonTheme.QueryBuilder} selectorIcon={propertyField ? propertyField.type === "string" ? "type-text" : "type-".concat(propertyField.type) : ""} selected={propertyField} label={propertyKeyLabel} onSelect={selection => updateField(selection.item, propertyKey, RHSInputType.Key)} onClick={() => update()} />
          </div>
        </div>}
      {showReminderTooltip && <TooltipReact placement={Placement.Left} offset={28} skidding={40} alwaysShow delayIn={10} delayOut={10} maxWidth={"200px"} text={t("boards.rhs.reminder-tooltip")} />}
    </div>;
};
export const EventAndPropertySelectorReact = withStyles(EventAndPropertySelector, css);
export const EventAndPropertySelectorEl = react2panel("mp-event-and-property-selector", EventAndPropertySelectorReact);